document.addEventListener('DOMContentLoaded', (event) => {

  const body = document.body;
  const scrollUp = 'scroll-up';
  const scrollUpNoBanner = 'scroll-up-no-banner';
  const scrollDown = 'scroll-down';
  const topNavHeight = 40;
  const delta = 120;
  let didScroll;
  let lastScrollTop = 0;

  function isDrawerOpen() {
    const mobileMenuDrawer = document.querySelector('mobile-menu-drawer');
    const cartDrawer = document.querySelector('cart-drawer');
    const mobileFilterDrawer = document.querySelector('mobile-filter-drawer');
    const storeAvailabilityDrawer = document.querySelector('store-availability-drawer');
    return (mobileMenuDrawer?.isOpen || cartDrawer?.isOpen || mobileFilterDrawer?.isOpen || storeAvailabilityDrawer?.isOpen);
  }
  
  window.addEventListener('scroll', () => {
    didScroll = true;
  });

  setInterval(function() {
    if (didScroll) {
        hasScrolled();
        didScroll = false;
    } else {
      if (!isDrawerOpen() && (window.pageYOffset <= 0 || window.pageYOffset < topNavHeight)) {
        body.classList.remove(scrollUp);
        body.classList.remove(scrollUpNoBanner);
        body.classList.remove(scrollDown);
        return;
      }
    }
  }, 250);

  function hasScrolled() {
    // Skip scroll handling if a drawer is open to avoid interfering with body position changes
    if (isDrawerOpen()) {
      return;
    }

    let currentScroll = window.pageYOffset;

    // Check not within the top nav height nor at zero
    if (currentScroll <= 0 || currentScroll < topNavHeight) {
      body.classList.remove(scrollUp);
      body.classList.remove(scrollUpNoBanner);
      body.classList.remove(scrollDown);
      return;
    }
    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - currentScroll) <= delta) return;

    if (currentScroll > lastScrollTop && !body.classList.contains(scrollDown)) {
      // down
      body.classList.remove(scrollUp);
      body.classList.remove(scrollUpNoBanner);
      body.classList.add(scrollDown);
      if (
        !document.getElementById('header').hasAttribute('nav-open') &&
        document.getElementById('klevu-quick-search').hasAttribute('open')
      ) {
        document.getElementById('overlay').classList.add('hidden');
      }
    } else if (
      currentScroll < lastScrollTop &&
      body.classList.contains(scrollDown)
    ) {
      // up
      body.classList.remove(scrollDown);
      if (
        !document.getElementById('header').hasAttribute('nav-open') &&
        document.getElementById('klevu-quick-search').hasAttribute('open')
      ) {
        document.getElementById('overlay').classList.remove('hidden');
      }
      if (document.getElementById('announcement-banner')) {
        body.classList.add(scrollUp);
      } else {
        body.classList.add(scrollUpNoBanner);
      }
    }
    lastScrollTop = currentScroll;

  }

});

// Mobile nav
// https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh + 'px');
});

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// Autoplay videos in iOS low power mode
// Define HTMLMediaElement.prototype 'playing' globally instead of in hero-video web component to avoid 'cannot redefine...' error
Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
  get: function () {
    return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
  }
});



/*
 * Shopify Dawn theme
 *
 */
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

// For review – not being used?
Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

// For review – not being used?
Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.formatMoney = function(t, r) {

  function e(t, r) {
    return void 0 === t ? r : t;
  }

  function a(t, r, a, o) {
    if (r = e(r, 2), a = e(a, ","), o = e(o, "."), isNaN(t) || null == t) return 0;
    t = (t / 100).toFixed(r);
    var n = t.split(".");
    return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + a) + (n[1] ? o + n[1] : "");
  }

  "string" == typeof t && (t = t.replace(".", ""));
  var o = "",
      n = /\{\{\s*(\w+)\s*\}\}/,
      i = r || window.moneyFormat;

  switch (i.match(n)[1]) {
    case "amount":
      o = a(t, 2);
      break;

    case "amount_no_decimals":
      o = a(t, 0);
      break;

    case "amount_with_comma_separator":
      o = a(t, 2, ".", ",");
      break;

    case "amount_with_space_separator":
      o = a(t, 2, " ", ",");
      break;

    case "amount_with_period_and_space_separator":
      o = a(t, 2, " ", ".");
      break;

    case "amount_no_decimals_with_comma_separator":
      o = a(t, 0, ".", ",");
      break;

    case "amount_no_decimals_with_space_separator":
      o = a(t, 0, " ", "");
      break;

    case "amount_with_apostrophe_separator":
      o = a(t, 2, "'", ".");
      break;

    case "amount_with_decimal_separator":
      o = a(t, 2, ".", ".");
  }

  return i.replace(n, o);
}